import { render } from "./CompanyInformationForm.vue?vue&type=template&id=506ac4e1&scoped=true"
import script from "./CompanyInformationForm.vue?vue&type=script&lang=js"
export * from "./CompanyInformationForm.vue?vue&type=script&lang=js"

import "./CompanyInformationForm.vue?vue&type=style&index=0&id=506ac4e1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506ac4e1"]])

export default __exports__